import { useEffect } from 'react';

export const useCloseXplanMenuOnInitialLoad = (): void => {
    useEffect(() => {
        const xplanMenu = document.querySelector('.left-nav .side-menu__submenu');
        const clientButton = document.querySelector('.left-nav .side-menu a[aria-label="Client"]') as
            | HTMLLinkElement
            | undefined;
        if (clientButton && xplanMenu?.classList.contains('shown')) {
            clientButton.click();
        }
    }, []);
};
